import { Injectable, Inject } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ExternalNavigateService {
  private angularRoot = '';

  constructor(@Inject(APP_BASE_HREF) private baseHref: string) {
    this.angularRoot = window.origin + this.normalizeBaseHref(baseHref);
  }

  public get isExternalPath() {
    return this.baseHref !== '/';
  }

  public navigate(link: string, isNewPage = false) {
    const url = this.getNavigationUrl(link);

    if (isNewPage) {
      window.open(url, '_blank');
      return;
    }
    window.location.href = url;
  }

  public getNavigationUrl(link: string) {
    const normalizedLink = this.normalizeLink(link);

    return this.angularRoot + normalizedLink;
  }

  private normalizeLink(link: string): string {
    return String(link || '').replace(/^\/+/, '');
  }

  private normalizeBaseHref(baseHref: string): string {
    const normalizedBaseHref = String(baseHref || '/').trim();

    if (!normalizedBaseHref || normalizedBaseHref === '/') {
      return '/';
    }

    return `/${normalizedBaseHref.replace(/^\/+|\/+$/g, '')}/`;
  }
}
